import { render, staticRenderFns } from "./View-File.vue?vue&type=template&id=838c39f6&scoped=true&"
import script from "./View-File.vue?vue&type=script&lang=js&"
export * from "./View-File.vue?vue&type=script&lang=js&"
import style0 from "./View-File.vue?vue&type=style&index=0&id=838c39f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838c39f6",
  null
  
)

export default component.exports